// import {baseUrl } from "@/api/index.ts";
var FileTypes = /** @class */ (function () {
    function FileTypes() {
    }
    /* 根据mimeType,找到文件类型，不在清单中的返回unknown类型 */
    FileTypes.prototype.getFileType = function (mime) {
        var mimeTypes = [
            { mime: "application/unknown", suffix: "unknown", type: "application", icon: "unknown.png" },
            { mime: "application/x-7z-compressed", suffix: "7z", type: "application", icon: "7z.png" },
            { mime: "application/postscript", suffix: "ai", type: "application", icon: "ai.png" },
            { mime: "video/x-msvideo", suffix: "avi", type: "video", icon: "avi.png" },
            { mime: "image/bmp", suffix: "bmp", type: "image", icon: "bmp.png" },
            { mime: "application/msword", suffix: "doc", type: "application", icon: "doc.png" },
            { mime: "application/vnd.ms-word.document.macroEnabled.12", suffix: "docm", type: "application", icon: "doc.png" },
            { mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", suffix: "docx", type: "application", icon: "doc.png" },
            { mime: "video/x-flv", suffix: "flv", type: "video", icon: "flv.png" },
            { mime: "image/gif", suffix: "gif", type: "image", icon: "gif.png" },
            { mime: "text/html", suffix: "html", type: "text", icon: "html.png" },
            { mime: "text/webviewhtml", suffix: "html", type: "text", icon: "html.png" },
            { mime: "image/jpg", suffix: "jpg", type: "image", icon: "jpg.png" },
            { mime: "image/jpeg", suffix: "jpg", type: "image", icon: "jpg.png" },
            { mime: "image/pjpeg", suffix: "jpg", type: "image", icon: "jpg.png" },
            { mime: "video/quicktime", suffix: "mov", type: "video", icon: "mov.png" },
            { mime: "video/mpeg", suffix: "mpeg", type: "video", icon: "mpeg.png" },
            { mime: "video/mp4", suffix: "mp4", type: "video", icon: "mp4.png" },
            { mime: "video/mpeg", suffix: "mp3", type: "audio", icon: "mp3.png" },
            { mime: "application/pdf", suffix: "pdf", type: "application", icon: "pdf.png" },
            { mime: "image/png", suffix: "png", type: "image", icon: "png.png" },
            { mime: "image/x-png", suffix: "png", type: "image", icon: "png.png" },
            { mime: "application/vnd.ms-powerpoint", suffix: "ppt", type: "application", icon: "ppt.png" },
            { mime: "application/vnd.ms-powerpoint.presentation.macroEnabled.12", suffix: "ppt", type: "application", icon: "ppt.png" },
            { mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation", suffix: "ppt", type: "application", icon: "ppt.png" },
            { mime: "application/octet-stream", suffix: "psd", type: "application", icon: "psd.png" },
            { mime: "application/x-rar-compressed", suffix: "rar", type: "application", icon: "rar.png" },
            { mime: "image/svg+xml", suffix: "svg", type: "image", icon: "svg.png" },
            { mime: "application/x-shockwave-flash", suffix: "swf", type: "application", icon: "swf.png" },
            { mime: "application/x-tar", suffix: "tar", type: "application", icon: "tar.png" },
            { mime: "image/tiff", suffix: "tif", type: "image", icon: "tif.png" },
            { mime: "text/plain", suffix: "txt", type: "application", icon: "txt.png" },
            { mime: "application/vnd.ms-works", suffix: "wps", type: "application", icon: "wps.png" },
            { mime: "application/kswps", suffix: "wps", type: "application", icon: "wps.png" },
            { mime: "application/kset", suffix: "wps", type: "application", icon: "wps.png" },
            { mime: "application/ksdps", suffix: "wps", type: "application", icon: "wps.png" },
            { mime: "application/vnd.ms-excel", suffix: "xls", type: "application", icon: "xls.png" },
            { mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", suffix: "xls", type: "application", icon: "xls.png" },
            { mime: "application/zip", suffix: "zip", type: "application", icon: "zip.png" },
            { mime: "application/x-zip-compressed", suffix: "zip", type: "application", icon: "zip.png" },
        ];
        var answer;
        for (var i = 0; i < mimeTypes.length; i++) {
            if (mimeTypes[i].mime == mime) {
                answer = mimeTypes[i];
            }
        }
        if (answer == undefined)
            answer = mimeTypes[0];
        // answer.icon= baseUrl + "/images/fileicon/" + answer.icon;
        return answer;
    };
    return FileTypes;
}());
export { FileTypes };
var fileTypes = new FileTypes();
export { fileTypes };
export default fileTypes;
